module.exports = __webpack_public_path__ + "img/gif4.gif.bak.53a45af1.gif";